import Reveal from "@/components/feature/Reveal";
import {
  LINE_URL,
  LINE_COLOR,
  TEL_DISPLAY,
  TEL_HREF,
  FORM_ANCHOR,
  MASCOT_CERT,
} from "@/constants";

type CtaBandProps = {
  eyebrow?: string;
  title?: string;
  text?: string;
  showMascot?: boolean;
};

export default function CtaBand({
  eyebrow = "まずはお気軽にご相談ください",
  title = "見積もり無料。写真を送るだけでもOKです。",
  text = "「これってお願いできる？」「これくらいだといくら？」という段階でも大丈夫。まずはお気軽にお問い合わせください。",
  showMascot = true,
}: CtaBandProps) {
  return (
    <section className="bg-primary-600 py-14 md:py-20">
      <div className="site-container">
        <Reveal>
          <div className="grid items-center gap-6 lg:grid-cols-[1fr_auto]">
            <div className="flex items-center gap-4">
              {showMascot ? (
                <div className="hidden h-24 w-24 shrink-0 items-center justify-center sm:flex">
                  <img src={MASCOT_CERT} alt="ぶたさん" className="h-full w-full object-contain" />
                </div>
              ) : null}
              <div>
                <p className="text-sm font-bold tracking-wide text-primary-100">{eyebrow}</p>
                <p className="mt-1 font-heading text-xl font-black leading-snug text-white md:text-3xl">
                  {title}
                </p>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-primary-50/90 md:text-base">{text}</p>
              </div>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
              <a
                href={TEL_HREF}
                className="flex cursor-pointer items-center justify-center gap-2 rounded-md bg-background-50 px-5 py-3.5 font-heading font-black text-primary-700 transition-all hover:bg-primary-50"
              >
                <i className="ri-phone-fill text-lg" />
                <span className="whitespace-nowrap text-sm">{TEL_DISPLAY}</span>
              </a>
              <a
                href={LINE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: LINE_COLOR }}
                className="flex cursor-pointer items-center justify-center gap-2 rounded-md px-5 py-3.5 font-heading font-black text-white transition-all hover:brightness-95"
              >
                <i className="ri-line-fill text-lg" />
                <span className="whitespace-nowrap text-sm">LINEで写真相談</span>
              </a>
              <a
                href={FORM_ANCHOR}
                className="flex cursor-pointer items-center justify-center gap-2 rounded-md border border-white/60 px-5 py-3.5 font-heading font-black text-white transition-all hover:bg-white/10"
              >
                <i className="ri-mail-send-line text-lg" />
                <span className="whitespace-nowrap text-sm">フォームで相談</span>
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}